export const categorieCosto = [
  ["profili", "Profili"], ["vetro", "Vetro"], ["ferramenta", "Ferramenta"], ["accessori", "Accessori"],
  ["trasporti", "Trasporti"], ["posa", "Posa"], ["manodopera", "Manodopera"], ["altri", "Altri"],
];

export const money = (n) => `€ ${Number(n || 0).toLocaleString("it-IT", { maximumFractionDigits: 0 })}`;
